import { useTranslation } from "react-i18next";

import { useDateTime } from "@/shared";

import { CompanyCardObjectDto } from "../../types/types";

interface UseCardStatusFunctionsProps {
  card: CompanyCardObjectDto;
}

const useCardStatusFunctions = ({ card }: UseCardStatusFunctionsProps) => {
  const { convertToCurrentDateFormat, formattedDate } = useDateTime();
  const { t } = useTranslation();

  const currDate = new Date();

  const threeMonthsPlusFromNow = new Date(
    currDate.setMonth(currDate.getMonth() + 3)
  ).toISOString();

  const today = new Date().toISOString();

  const expirationDate = card.validUntil;

  const checkIfExpirationDayIsInThreeMonths = () => {
    if (expirationDate) {
      return expirationDate > today && expirationDate <= threeMonthsPlusFromNow;
    }
  };

  const checkIfExpired = () => {
    if (expirationDate) return expirationDate < today;
  };

  const offlineStatusText = t("Dashboard##tooltip##offline card", {
    lastSeen: formattedDate(card.disconnectedAt)
  });

  const connectedStatusInExpireTooltipText = t(
    "Dashboard##tooltip##connected card expire soon",
    {
      expirationDate:
        card.validUntil && convertToCurrentDateFormat(card.validUntil)
    }
  );

  const onlineStatusText = t("Company cards##badge tooltip##Online");

  const expiredStatusText = t("Company cards##badge tooltip##Expired");

  return {
    offlineStatusText,
    checkIfExpirationDayIsInThreeMonths,
    checkIfExpired,
    expiredStatusText,
    connectedStatusInExpireTooltipText,
    onlineStatusText
  };
};

export default useCardStatusFunctions;
